<template>
  <div class="border-dashboard" style="background-color: #ffefc3; height: 100%">
    <!-- Loading Overlay -->
    <v-overlay v-model="activeLoading" class="align-center justify-center" :persistent="true" contained>
      <v-progress-circular color="primary" indeterminate size="32" width="3" />
    </v-overlay>
    <div :class="$vuetify.display.smAndDown ? 'px-6 py-4' : 'px-12 py-6'" style="border-bottom: 1px solid #7b7b7b">
      <p class="mb-0 text-body-2">
        <v-icon class="mr-2">mdi-star</v-icon><span class="ml-1">Complete your profile</span>
      </p>
    </div>

    <div>
      <div class="font-weight-bold" :class="$vuetify.display.smAndDown ? 'px-6 py-6' : 'px-10 py-10'">
        {{
          showAskForGraduationDate
            ? 'When do you expect to graduate from high school?'
            : "No problem! We'll remind you about this question later on."
        }}
      </div>
      <div class="pb-6" :class="$vuetify.display.smAndDown ? 'px-6' : 'px-10'">
        <v-form
          ref="form"
          :class="[
            { 'd-none': !showAskForGraduationDate },
            $vuetify.display.smAndDown ? 'd-flex flex-column ga-4' : 'd-flex ga-4'
          ]"
        >
          <v-autocomplete
            v-model="highSchoolExpectedGraduationMonth"
            :items="months"
            @update:modelValue="updateGraduationMonth"
            label="Month"
            variant="outlined"
            :rules="[(v) => !!v || 'Month is required']"
          />

          <v-autocomplete
            v-model="highSchoolExpectedGraduationYear"
            :items="graduationYear"
            label="Year"
            variant="outlined"
            @update:modelValue="updateGraduationYear"
            :rules="[(v) => !!v || 'Year is required']"
          />

          <div :class="$vuetify.display.smAndDown ? 'd-flex justify-end mt-2' : ''">
            <v-btn
              color="black"
              baseColor="red"
              @click="setSelection"
              variant="flat"
              rounded="md"
              class="font-weight-bold"
              :disabled="!highSchoolExpectedGraduationMonth || !highSchoolExpectedGraduationYear"
              style="height: 56px; margin-right: 0px !important"
            >
              Set
            </v-btn>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { AjaxLoader } from '../../mixins/ajaxLoader';
import { DataLayerMixin } from '../../mixins/dataLayerMixin';
import { Logger } from '../../mixins/logger';
import moment from 'moment-timezone';

export default defineComponent({
  name: 'DashboardCompleteProfileCard',

  data() {
    return {
      showAskForGraduationDate: true,
      highSchoolExpectedGraduationMonth: '',
      highSchoolExpectedGraduationYear: '',
      formattedHighSchoolGraduationDate: null,
      months: 'January February March April May June July August September October November December'.split(' ')
    };
  },

  mixins: [AjaxLoader, DataLayerMixin, Logger],

  props: {
    expectedGraduationDate: {
      type: String,
      default: ''
    }
  },

  computed: {
    graduationDate() {
      return moment(this.expectedGraduationDate).isValid() ? moment(this.expectedGraduationDate) : null;
    },

    graduationYear() {
      const currentYear = new Date().getFullYear();
      const range = 6;
      let futureYears = Array.from({ length: range }, (_, i) => currentYear + i);

      if (this.graduationDate) {
        const selectedYear = parseInt(this.graduationDate.format('YYYY'), 10);
        if (!futureYears.includes(selectedYear)) {
          futureYears.unshift(selectedYear);
        }
      }
      return futureYears;
    }
  },

  methods: {
    skipCompleteYourProfile() {
      this.showAskForGraduationDate = !this.showAskForGraduationDate;
    },
    async setSelection() {
      this.asuoDataLayerClick('accelerateDashboard', '4');
      if (this.highSchoolExpectedGraduationMonth && this.highSchoolExpectedGraduationYear) {
        this.formattedHighSchoolGraduationDate = moment(
          `${this.highSchoolExpectedGraduationYear}-${this.highSchoolExpectedGraduationMonth}-01`,
          'YYYY-MMMM-DD'
        ).format('YYYY-MM-DD');
      }

      // Patch the expected graduation date
      await this.$conn
        .patchLearnerContactInfo({ highSchoolExpectedGraduationDate: this.formattedHighSchoolGraduationDate })
        .then(async function (res) {
          this.logInfo('patchLearnerInfo', res.data.message);
        })
        .catch((err) => {
          this.logError('patchLearnerInfo', err);
        })
        .finally(() => {
          window.location.reload();
        });
    },
    updateGraduationMonth(updatedMonth) {
      this.highSchoolExpectedGraduationMonth = updatedMonth;
      this.asuoDataLayerClick('accelerateDashboard', '3', { text: updatedMonth });
    },
    updateGraduationYear(updatedYear) {
      this.highSchoolExpectedGraduationYear = updatedYear;
      this.asuoDataLayerClick('accelerateDashboard', '3', { type: 'year', text: updatedYear });
    }
  }
});
</script>

<style lang="scss" scoped></style>
